// extracted by mini-css-extract-plugin
module.exports = {"white":"AppLogo_white_1-RN-","black":"AppLogo_black_3dkrK"};